import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { OrderByPipeModule } from '@vfde-fe/ngx-lib/pipes/order-by';
import { SafeUrlPipeModule } from '@vfde-fe/ngx-lib/pipes/safe-url';
import { LandLinePipeModule } from '@vfde-fe/ngx-lib/pipes/landline';
import { ReplaceZeroPhonePipeModule } from '@vfde-fe/ngx-lib/pipes/replace-zero-phone';
import { MsisdnPipeModule } from '@vfde-fe/ngx-lib/pipes/msisdn';
import { PriceModule } from '@vfde-fe/ngx-lib/pipes/price';
import { PermissionDirectiveModule } from '@vfde-fe/ngx-lib/directives/permission';
import { UnavailableTransactionModule } from '@vfde-fe/ngx-lib/directives/unavailable-transaction';
import { DetectDataLossDirectiveModule } from '@vfde-fe/ngx-lib/directives/detect-data-loss';
import { ContractNamePipeModule } from '@vfde-fe/ngx-lib/pipes/contract-name';
import { DotToCommaPipeModule } from '@vfde-fe/ngx-lib/pipes/dot-to-comma';
import { GMBPipeModule } from '@vfde-fe/ngx-lib/pipes/gmb';
import { IframeHeightDirectiveModule } from '@vfde-fe/ngx-lib/directives/IframeHeight';
import { NavigateToHelpSupportDirectiveModule } from '@vfde-fe/ngx-lib/directives/navigate-to-help-support';
import {HideForAppDirectiveModule} from '@vfde-fe/ngx-lib/directives/hideForApp';

/** modules  */
@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        OrderByPipeModule,
        MsisdnPipeModule,
        PriceModule,
        SafeUrlPipeModule,
        PermissionDirectiveModule,
        UnavailableTransactionModule,
        HideForAppDirectiveModule,
        ReplaceZeroPhonePipeModule,
        DetectDataLossDirectiveModule,
        ContractNamePipeModule,
        LandLinePipeModule,
        DotToCommaPipeModule,
        GMBPipeModule,
        IframeHeightDirectiveModule,
        NavigateToHelpSupportDirectiveModule,
    ],
    exports: [
        OrderByPipeModule,
        MsisdnPipeModule,
        PriceModule,
        SafeUrlPipeModule,
        PermissionDirectiveModule,
        UnavailableTransactionModule,
        HideForAppDirectiveModule,
        ReplaceZeroPhonePipeModule,
        DetectDataLossDirectiveModule,
        ContractNamePipeModule,
        LandLinePipeModule,
        DotToCommaPipeModule,
        GMBPipeModule,
        IframeHeightDirectiveModule,
        NavigateToHelpSupportDirectiveModule,
    ],
})
export class UiHelpersModule { }
